import { render, staticRenderFns } from "./ListDelivery.vue?vue&type=template&id=1133c4c3&scoped=true&"
import script from "./ListDelivery.vue?vue&type=script&lang=js&"
export * from "./ListDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ListDelivery.vue?vue&type=style&index=0&id=1133c4c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133c4c3",
  null
  
)

export default component.exports